export const ANALYTICS_REPORTING_PATH = "/apps/analytics-reporting";

export const ANALYTICS_DASHBOARD_PATH = `${ANALYTICS_REPORTING_PATH}/dashboard`;

export const REPORTS_PATH = `${ANALYTICS_REPORTING_PATH}/reports`;
export const getReportViewPath = (id: string | number) =>
  `${REPORTS_PATH}/view/${id}`;

export const SCHEDULED_REPORTS_PATH = `${ANALYTICS_REPORTING_PATH}/scheduled`;
export const getScheduledReportViewPath = (id: string | number) =>
  `${SCHEDULED_REPORTS_PATH}/view/${id}`;

export const DATA_EXPORTS_PATH = `${ANALYTICS_REPORTING_PATH}/exports`;
export const getDataExportViewPath = (id: string | number) =>
  `${DATA_EXPORTS_PATH}/view/${id}`;
